// extracted by mini-css-extract-plugin
export default {"aboutDiv":"About_aboutDiv__Qjnhe","avatar":"About_avatar__qTK7e","content":"About_content__WXr36"};